import { render, staticRenderFns } from "./DeliveryConfirm.vue?vue&type=template&id=8f781958"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports